import React from 'react';
import ErrorWrapper from '@/app/ErrorWrapper';
import { useEffect, useState } from 'react';
import { Button, Card, List, Modal, notification } from 'antd';
import { documentsApi, filesApi, programsApi } from '@/api';
import { lessonsApi } from '@/api/lessons/lessonsApi';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next'; // Added import
import { DOCUMENT_TYPE } from '@/utils/constants';

const LessonModalComponent = ({ open, handleToggleModal, selectedLesson, isStudentEnrolled }) => {
    const { t } = useTranslation(); // Added hook
    const authData = useSelector((state) => state.auth);
    const [isLoadingDetail, setIsLoadingDetail] = useState(false);
    const [fileUploading, setFileUploading] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [videoUrl, setVideoUrl] = useState(null);

    const getDetail = (id) => {
        lessonsApi
            .getDetail(id)
            .then((res) => {
                setVideoUrl(res?.data?.data?.recordedLink);
            })
            .catch((err) => console.error(err))
            .finally(() => setIsLoadingDetail(false));
    };
    useEffect(() => {
        if (selectedLesson) {
            getDetail(selectedLesson?.id);
        }
    }, [selectedLesson]);

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
        setVideoUrl(null);
    };

    const handleUpload = async () => {
        const formData = new FormData();
        formData.append('video', selectedFile);

        if (selectedFile instanceof File) {
            setFileUploading(true);
            filesApi
                .upload({
                    fileName: selectedFile.name,
                    fileType: selectedFile.type,
                    entityName: 'lessons'
                })
                .then((res) => {
                    return axios.put(res?.data?.data?.url, selectedFile, {
                        headers: {
                            'Content-Type': selectedFile.type
                        }
                    });
                })
                .then(() => {
                    filesApi
                        .view({
                            fileName: selectedFile.name,
                            entityName: 'lessons'
                        })
                        .then((res) => {
                            setVideoUrl(res?.data?.data?.url);
                            notification.success({
                                message: t('LessonModal_Student_Upload_Success_Title')
                            });
                        });
                })
                .catch((err) => {
                    console.error('Video upload error:', err);
                    notification.error({
                        message: t('LessonModal_Student_Upload_Failed_Title'),
                        description:
                            err.response?.data?.message ||
                            t('LessonModal_Student_Upload_Failed_Description')
                    });
                })
                .finally(() => setFileUploading(false));
        }
    };

    const handleUpdateSchedule = () => {
        if (selectedFile) {
            documentsApi
                .create({
                    name: 'Lesson Record Link',
                    fileType: selectedFile.type,
                    documentType: DOCUMENT_TYPE.RECORD_LESSON,
                    fileName: selectedFile.name,
                    entityName: 'lessons',
                    entityId: selectedLesson?.id
                })
                .then(() => {
                    notification.success({ message: t('Profile_Notify_UpdateSuccess') });
                    handleToggleModal();
                })
                .catch((err) => {
                    notification.success({ message: t('Profile_Notify_UpdateFailed') });
                });
        }
    };

    return (
        <Modal
            open={open}
            onCancel={handleToggleModal}
            closable={false}
            footer={[
                <Button
                    key="cancel"
                    onClick={handleToggleModal}>
                    {t('LessonModal_Student_Button_Cancel')}
                </Button>,
                authData?.roles[0]?.name == 'Teacher' && (
                    <Button
                        key="submit"
                        type="primary"
                        disabled={isLoadingDetail || fileUploading}
                        loading={isLoadingDetail || fileUploading}
                        onClick={() => handleUpdateSchedule()}>
                        {t('LessonModal_Student_Button_Ok')}
                    </Button>
                )
            ]}>
            <Card>
                {authData?.roles[0]?.name == 'Teacher' && (
                    <div
                        className={`flex flex-col gap-4 items-center ${
                            videoUrl ? 'mb-[20px]' : ''
                        }`}>
                        <input
                            className="w-full"
                            type="file"
                            accept="video/*"
                            onChange={handleFileChange}
                        />
                        <Button
                            onClick={handleUpload}
                            type="primary"
                            loading={fileUploading}
                            disabled={fileUploading || !selectedFile}>
                            {t('LessonModal_Student_Button_Upload')}
                        </Button>
                    </div>
                )}
                {authData?.roles[0]?.name == 'Student' && !isStudentEnrolled && (
                    <h3>{t('LessonModal_Student_Enroll_Prompt')}</h3>
                )}
                {authData?.roles[0]?.name == 'Student' && !videoUrl && isStudentEnrolled && (
                    <h3>{t('LessonModal_Student_NoRecord_Prompt')}</h3>
                )}
                {videoUrl &&
                    ((isStudentEnrolled && authData?.roles[0]?.name == 'Student') ||
                        authData?.roles[0]?.name == 'Teacher') && (
                        <video controls={true}>
                            <source src={videoUrl}></source>
                        </video>
                    )}
            </Card>
        </Modal>
    );
};

LessonModalComponent.displayName = 'LessonModal';

const LessonModal = (props) => {
    return (
        <ErrorWrapper>
            <LessonModalComponent
                data-id="LessonModal-cpn"
                {...props}
            />
        </ErrorWrapper>
    );
};

export default LessonModal;
